import { useCabinetText } from '../../i18n/CabinetLocale';
import React from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

export default function DraftRecoveryNotice({ buffer, label, disabled = false, onRestore }) {
  const t = useCabinetText();
  return <>
    {buffer.recovery && <div className="ap-save-notice ap-save-notice--warning" role="status">
      <AlertTriangle size={19} aria-hidden="true" />
      <div><strong>{t("Найден несохранённый черновик:")}{' '}{label}</strong>
        <p>{t("Он сохранён в этой вкладке для вашей учётной записи. Восстановите его и проверьте перед отправкой: данные на сервере могли измениться.")}</p>
        <div className="ap-inline-actions">
          <button type="button" className="ap-button ap-button--primary ap-button--sm" disabled={disabled} onClick={() => { buffer.restore(); onRestore?.(); }}><RotateCcw size={14} />{t("Восстановить черновик")}</button>
          <button type="button" className="ap-button ap-button--secondary ap-button--sm" disabled={disabled} onClick={() => buffer.dismissRecovery()}>{t("Оставить данные сервера")}</button>
        </div>
      </div>
    </div>}
    {buffer.storageError && <div className="ap-save-notice ap-save-notice--warning" role="alert">
      <AlertTriangle size={19} aria-hidden="true" /><div><strong>{t("Браузер не разрешил сохранить резервный черновик.")}</strong><p>{t("Не закрывайте вкладку. Введённые данные пока доступны на экране; повторите сохранение на сервер.")}</p></div>
    </div>}
  </>;
}
